import { render, staticRenderFns } from "./ScreenLockLoader.vue?vue&type=template&id=4514b0e3&scoped=true&lang=pug"
var script = {}
import style0 from "./ScreenLockLoader.vue?vue&type=style&index=0&id=4514b0e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514b0e3",
  null
  
)

export default component.exports